import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
  isModal?: boolean;
  onClose?: () => void;
}

function MenuTop({ isModal = false, onClose }: Props) {
  const navigate = useNavigate();

  return (
    <Container>
      <IconButton
        onClick={() => {
          if (isModal && onClose) {
            onClose();
          } else {
            navigate(-1);
          }
        }}
      >
        <img src="/assets/images/arrow/arrow-left-black.svg" alt="back" />
      </IconButton>
      <Title>전체메뉴</Title>
      <ButtonBox>
        <IconButton onClick={() => navigate('/quick-search')}>
          <img src="/assets/images/icon/search-black.svg" alt="search" />
        </IconButton>
        <IconButton onClick={() => navigate('/')}>
          <img src="/assets/images/icon/home-black.svg" alt="home" />
        </IconButton>
      </ButtonBox>
    </Container>
  );
}

export default MenuTop;

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 6px;
  align-items: center;
  gap: 2px;
  position: sticky;
  top: 0;
  background-color: #f3f4f6;
  z-index: 1000;
`;

const IconButton = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;

  & > img {
    width: 24px;
    height: 24px;
  }
`;

const Title = styled.div`
  display: flex;
  height: 44px;
  align-items: center;
  flex: 1 0 0;

  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const ButtonBox = styled.div`
  display: flex;
  align-items: center;
`;

const Left = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
`;
const Right = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  cursor: pointer;
`;
const Span = styled.span`
  font-size: 13px;
  color: #008aff;
  font-weight: 700;
`;
const InputBox = styled.div<{ focus?: boolean }>`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0px 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: ${({ focus }) => (focus ? 'none' : '9999px')};
  border-top-left-radius: ${({ focus }) => (focus ? '10px' : '9999px')};
  border-top-right-radius: ${({ focus }) => (focus ? '10px' : '9999px')};
  border: ${({ focus }) => (focus ? 'solid 1px #b9b8b8' : 'solid 1px #b9b8b8')};
  background-color: #f7f8fc;
`;

const Input = styled.input`
  width: 100%;
  outline: none;
  border: none;
  background-color: transparent;
`;

const AutoComplete = styled.ul`
  min-width: 240px;
  width: 100%;
  position: absolute;
  top: 26px;
  z-index: 9999;
  background-color: #fff;
  border-left: solid 1px #b9b8b8;
  border-right: solid 1px #b9b8b8;
  border-bottom: solid 1px #b9b8b8;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  max-width: inherit;
  max-height: 400px;
  overflow-y: auto;

  li {
    width: 100%;
    padding: 10px;
    border-bottom: solid 1px #b9b8b8;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;

    &:hover {
      background-color: rgb(255, 254, 223);
    }

    &.no-hover {
      &:hover {
        background-color: transparent;
      }
    }

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    div > div:first-child {
      flex: 6;
    }

    div > div:nth-child(2) {
      flex: 4;
      justify-content: flex-end;
    }
  }

  :last-child {
    border-bottom: none;
  }
`;

const AutoCompleteText = styled.div<{ color?: string }>`
  display: inline-block;
  min-width: 0;
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.color};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const AuctionType = styled.div<{ type: string }>`
  justify-content: flex-end;
  padding: 2px 8px;
  border-radius: 999px;
  max-width: fit-content;
  font-size: 12px;
  background-color: ${(props) =>
    (props.type === 'a' && 'rgb(255, 219, 214)') ||
    (props.type === 'p' && 'rgb(222, 237, 255)') ||
    (props.type === 'e' && '#fffce3')};
  color: ${(props) =>
    (props.type === 'a' && 'rgb(216, 72, 54)') ||
    (props.type === 'p' && 'rgb(12, 100, 206)') ||
    (props.type === 'e' && '#d87300')};
  font-weight: 500;
`;

const StatusBadge = styled.div`
  justify-content: flex-end;
  padding: 2px 8px;
  border-radius: 999px;
  max-width: fit-content;
  font-size: 12px;
  background-color: #70737c14;
  color: #37383c9c;
  font-weight: 500;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TooltipBox = styled.div`
  position: absolute;
  top: 26px;
  background-color: #008aff;
  border-radius: 9999px;
  padding: 8px 12px;
  color: white;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  z-index: 10;
`;

const TooltipArrow = styled.div`
  position: absolute;
  top: -6px;
  left: calc(50% - 6px);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #008aff;
`;

const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 14px;
  cursor: pointer;
`;
